import { type Theme } from "@mui/material";
import { AgentStages } from "@src/appV2/redesign/interface/agent";

interface StatusChipStyle {
  backgroundColor: string | undefined;
  color: string | undefined;
  borderColor: string | undefined;
}

export function getWorkerStageChipStyle(stage: string, theme: Theme): StatusChipStyle {
  const { statusChip } = theme.palette;

  const variant = (() => {
    switch (stage) {
      case AgentStages.ENROLLED: {
        return statusChip?.success;
      }
      case AgentStages.ONBOARDING: {
        return statusChip?.pending;
      }
      case AgentStages.PROBATION:
      case AgentStages.RESTRICTED: {
        return statusChip?.warning;
      }
      case AgentStages.DEACTIVATED: {
        return statusChip?.error;
      }
      default: {
        return statusChip?.muted;
      }
    }
  })();

  return {
    backgroundColor: variant?.background,
    color: variant?.text,
    borderColor: variant?.text,
  };
}
